import { render, staticRenderFns } from "./GuardiansContact.vue?vue&type=template&id=43c39579&"
import script from "./GuardiansContact.vue?vue&type=script&lang=ts&"
export * from "./GuardiansContact.vue?vue&type=script&lang=ts&"
import style0 from "./GuardiansContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports